import fieldValidationListData from './field-validation-list-data';

import { v4 as uuid } from 'uuid';

export default {
  namespaced: true,

  state: {
    list: null,
    current: null,
  },

  getters: {
    current(state) {
      return state.current;
    },

    get(state) {
      return (id) => {
        let found = null;

        if (state.list) {
          found = state.list.find((i) => i.id === id);
        }

        if (!found) {
          if (state.current && state.current.id === id) {
            found = state.current;
          }
        }

        return found;
      };
    },

    list: (state) => state.list,

    listForTable(state, getters, rootState, rootGetters) {
      const field =
        rootGetters['builder/fieldCurrent/current'];

      return fieldValidationListData.adaptFieldsForTable(
        field,
        state.list,
        rootGetters,
      );
    },
  },

  mutations: {
    bind(state, payload) {
      state.list = payload;
    },

    persist(state) {
      const validations = state.list;

      const index = validations.findIndex(
        (validation) =>
          validation.key === state.current.key,
      );

      if (index > -1) {
        validations.splice(index, 1, state.current);
      } else {
        validations.push(state.current);
      }

      state.current = null;
    },

    new(state) {
      state.current = {
        id: uuid(),
      };
    },

    edit(state, payload) {
      state.current = JSON.parse(JSON.stringify(payload));
    },

    delete(state, payload) {
      const validations = state.list;

      if (!validations || !validations.length) {
        return;
      }

      const index = validations.findIndex(
        (e) => e.id === payload.id,
      );

      if (index > -1) {
        validations.splice(index, 1);
      }
    },

    clear(state) {
      state.current = null;
    },
  },

  actions: {
    persist({ getters, commit, rootGetters }) {
      const field =
        rootGetters['builder/fieldCurrent/current'];
      const validation = getters.current;
      const input = rootGetters[
        'builder/fieldValidation/input'
      ](field, validation.key);

      if (!input) {
        validation.value = true;
      }

      return commit('persist');
    },
  },
};
